import InnerComponent from '@Components/Purchase/Rfq/ViewRfq';
import orgContainer from '@Components/AppContainer';

const ViewRfq = () => ((orgContainer(InnerComponent)));
export default ViewRfq;